import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class RolesDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  idRole: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  alias: string = "";
  permissions: any = [];
  aliases: any = {
    '^/.*$': 'Acceso ilimitado',
    '^/company.*$': 'Empresa',
    '^/business.*$': 'Giro',
    '^/role.*$': 'Roles',
    '^/user/admin.*$': 'Administradores',
    '^/user/candidate.*$': 'Candidatos',
    '^/question.*$': 'Preguntas',
    '^/section.*$': 'Secciones',
    '^/resource.*$': 'Recursos',
    '^/skill.*$': 'Competencias',
    '^/test/.*$': 'Reporte',
    '^/profile.*$': 'Perfiles',
    '^/support.*$': 'Soporte'
  }
  createdAt: string = "";
  updatedAt: string = "";


  mounted (){
    const _ = this;
    _.filterDate();
    _.getByRoles();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getByRoles(){
    const _ = this;
    _.idRole = location.href.split("/");
    _.idRole = _.idRole[5];
    _.isLoading = true;
    _.detailService.getByRoles(_.idRole).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.alias = data["data"].role.alias;
      _.createdAt = data["data"].role.createdAt;
      _.updatedAt = data["data"].role.updatedAt;
      _.permissions = data["data"].role.permissions;
      _.permissions.forEach(permission => {
        permission.alias = _.aliases[permission.endpoint];
      });
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
